import { Stack, TextField } from "@mui/material";
import type { FC, KeyboardEvent } from "react";
import { useState } from "react";
import DatePicker from "../datePicker/DatePickerV2";
import dayjs, { ISO_DATE_FORMAT } from "../../dayjs";

interface Props {
  readonly label?: string;
  readonly dateLabel?: string;
  readonly date: string | null; // YYYY-MM-DD
  readonly type?: "text" | "number";
  readonly readonly?: boolean;
  readonly onSubmit: (text: string, date: string | null) => void | Promise<void>;
}

const NoteStampedInput: FC<Props> = (props) => {
  const [disabled, setDisabled] = useState(false);
  const [text, setText] = useState("");
  const [date, setDate] = useState<string | null>(props.date);

  const handleKeyPress = async (e: KeyboardEvent) => {
    if (e.key === "Enter") {
      try {
        setDisabled(true);
        await props.onSubmit(text, date);
        setText("");
        setDate(props.date);
      } finally {
        setDisabled(false);
      }
    }
  };
  const inputDisabled = props.readonly || disabled;
  return (
    <Stack
      direction="row"
      spacing={1}
      sx={{
        justifyContent: "space-between",
      }}
    >
      <TextField
        label={props.label}
        value={text}
        type={props.type}
        onKeyPress={handleKeyPress}
        onChange={(e) => setText(e.target.value)}
        style={{ flexGrow: 1 }}
        disabled={inputDisabled}
      />
      <DatePicker
        onKeyPress={handleKeyPress}
        disabled={inputDisabled}
        label={props.dateLabel}
        onChange={(d) => setDate(d?.format(ISO_DATE_FORMAT) ?? null)}
        value={date ? dayjs(date, ISO_DATE_FORMAT) : null}
      />
    </Stack>
  );
};

export default NoteStampedInput;
